import { Component, OnDestroy, OnInit } from '@angular/core';
import { HomepageService } from 'src/app/shared/services/homepage/homepage.service';
import { UtilService, VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-successtories',
  templateUrl: './successtories.component.html',
  styleUrls: ['./successtories.component.scss']
})
export class SuccesstoriesComponent implements OnInit, OnDestroy {

  successStories = [];
  isMobile: any;
  breakpoints = {
    600: { perView: 1.1, focusAt: 0, showArrows: false },
    992: { perView: 1, focusAt: 0 }
  };
  successStoriesObservable;

  constructor(
    private homepageService: HomepageService,
    public utilService: UtilService,
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.getSuccessStories();
  }

  ngOnDestroy() {
    if (this.successStoriesObservable) {
      this.successStoriesObservable.unsubscribe();
    }
  }

  getSuccessStories() {
    this.successStoriesObservable = this.homepageService.getSuccessStories().subscribe((res: any) => {
      this.successStories = res.data.data;
    });
  }

  getBannerImage(story): string {
    if (this.isMobile && story.mobile && story.mobile.cdn_path) {
      return story.mobile.cdn_path + '?w=auto';
    } else if (story.desktop && story.desktop.cdn_path) {
      return story.desktop.cdn_path + '?w=auto';
    } else {
      return this.utilService.defaultImg;
    }
  }
}
